import React from 'react';
import BaseTasksPage from '../BaseTasksPage';
import useLaunchFromContractNavigator from './launchFromContractNavigator';
import LaunchFromContractSteps, { LaunchFromContractStepId } from './LaunchFromContractSteps';
import { ProjectPlanTask } from '../projectPlanTaskService';

export default function ManageKeyDatesPage() {
  const navigator = useLaunchFromContractNavigator();

  return (
    <BaseTasksPage
      filterFunc={(task: ProjectPlanTask) => task.isKeyDate}
      roadmap={<LaunchFromContractSteps currentStep={LaunchFromContractStepId.KEY_DATES} />}
      onPrevClicked={navigator.openSelectGroupsPage}
      onNextClicked={navigator.openAllTasksPage}
      forceShowKeyDatesOnly
      showNonAiTasksOnlyOption
    />
  );
}
